const s = {
  name: "Payout",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25.7,5.7L20,0l-5.7,5.7l1.4,1.4L19,3.8V12h2V3.8l3.3,3.3L25.7,5.7z"/>
		<path class="st0" d="M20,21c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,21,20,21z M16,27c0-2.2,1.8-4,4-4s4,1.8,4,4
			c0,2.2-1.8,4-4,4S16,29.2,16,27z"/>
		<path class="st0" d="M4,18h5v2H6v3H4V18z"/>
		<path class="st0" d="M6,31v3h3v2H4v-5H6z"/>
		<path class="st0" d="M34,34v-3h2v5h-5v-2H34z"/>
		<path class="st0" d="M31,20h3v3h2v-5h-5V20z"/>
		<path class="st0" d="M0,40h40V14H0V40z M2,38V16h36v22H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Payout
};
